/**
 * 收件人操作按鈕組件
 * 新增收件人按鈕（To/CC/BCC）或出席者按鈕（必要/選擇性），以及清除選擇按鈕
 */

import * as React from "react";
import { Button, makeStyles, tokens } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { useAppContext } from "../../contexts/AppContext";

const useStyles = makeStyles({
  actions: {
    marginTop: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    padding: "16px 10px 20px 10px",
    backgroundColor: "#F0F8FC",
    borderRadius: "8px",
    border: `1px solid #B3D9F2`,
    flexShrink: 0,
  },
  primaryActions: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  fullWidthButton: {
    width: "100%",
    justifyContent: "center",
    fontWeight: "500",
  },
  divider: {
    height: "1px",
    backgroundColor: "#B3D9F2",
    margin: "16px 0",
    flexShrink: 0,
  },
});

const RecipientActions = ({ 
  hasSelection, 
  onAddTo, 
  onAddCc, 
  onAddBcc, 
  onAddRequiredAttendees,
  onAddOptionalAttendees,
  onClear 
}) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const { adapter } = useAppContext();
  
  // 判斷是否為 Calendar 模式
  const isCalendarMode = adapter.getName() === 'Calendar';

  return (
    <>
      <div className={styles.divider}></div>
      <div className={styles.actions}>
        <div className={styles.primaryActions}>
          {isCalendarMode ? (
            // Calendar 模式：顯示出席者按鈕
            <>
              <Button 
                appearance="primary" 
                className={styles.fullWidthButton}
                onClick={onAddRequiredAttendees} 
                disabled={!hasSelection}
              >
                {t('add_required_attendees') || '新增必要出席者'}
              </Button>
              <Button 
                appearance="primary" 
                className={styles.fullWidthButton}
                onClick={onAddOptionalAttendees} 
                disabled={!hasSelection}
              >
                {t('add_optional_attendees') || '新增選擇性出席者'}
              </Button>
            </>
          ) : (
            // 郵件模式：顯示收件人按鈕
            <>
              <Button 
                appearance="primary" 
                className={styles.fullWidthButton}
                onClick={onAddTo} 
                disabled={!hasSelection}
              >
                {t('add_recipient')}
              </Button>
              <Button 
                appearance="primary" 
                className={styles.fullWidthButton}
                onClick={onAddCc} 
                disabled={!hasSelection}
              >
                {t('add_cc')}
              </Button>
              <Button 
                appearance="primary" 
                className={styles.fullWidthButton}
                onClick={onAddBcc} 
                disabled={!hasSelection}
              >
                {t('add_bcc')}
              </Button>
            </>
          )}
          <Button 
            appearance="outline" 
            className={styles.fullWidthButton}
            onClick={onClear} 
            disabled={!hasSelection}
          >
            {t('clear_selection')}
          </Button>
        </div>
      </div>
    </>
  );
};

export default RecipientActions;

